export enum CreatePresentationDialogPaneType {
    BLANK_PRESENTATION = "blank",
    GENERATE_WITH_AI = "generate-with-ai",
    TEAM_TEMPLATES = "team-templates",
    STARTER_TEMPLATES = "starter-templates",
    CHOOSE_TEMPLATE = "choose-template",
    IMPORT_PPT = "import-ppt"
}
